import { isEmpty } from '@s-libs/micro-dash';
import clsx from 'clsx';

function InputValidation({
  className = 'mt-2',
  validationErrors,
}: {
  className?: string;
  validationErrors: string[];
}) {
  if (isEmpty(validationErrors)) return null;

  return (
    <div className={clsx('flex text-xs gap-1 flex-wrap font-semibold', className)}>
      {validationErrors.map((error) => (
        <div className="bg-red-400 p-1 text-white rounded-sm" key={error}>
          {error}
        </div>
      ))}
    </div>
  );
}

export default InputValidation;
